export default __webpack_public_path__ + "static/media/FlyingFrog6.90403d52.png";